type OverflowValue = 'hidden' | 'auto' | 'scroll' | 'visible' | 'inherit' | 'initial' | 'unset';

class DomService {
  constructor() {
  }

  public setBodyOverflow(overflow: OverflowValue) {
    document.body.style.overflow = overflow;
  }

  // public giveFocusToClosestFocusableElement(element: HTMLElement) {
  //   const firstFocusableElement = element.closest(`[tabindex]:not([tabindex="-1"])`) as HTMLElement;
  //   if (!firstFocusableElement) {
  //     return;
  //   }
  //   firstFocusableElement.focus();
  // }
}

export default new DomService();